<p-dialog [(visible)]="displayModal" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
    closable="true">
    <ng-template pTemplate="header">
        <div *ngIf="displayModal === 'about'" class="h4">
            <fa-icon [icon]='["far","store"]' class="me-2"></fa-icon>
            About the restaurant
        </div>
        <div *ngIf="displayModal === 'legal'" class="h4">
            <fa-icon [icon]='["far","balance-scale"]' class="me-2"></fa-icon>
            Legal stuff
        </div>
        <div *ngIf="displayModal === 'business'" class="h4">
            <fa-icon [icon]='["far","info-circle"]' class="me-2"></fa-icon>
            Some Business Info
        </div>
        <div *ngIf="displayModal === 'banking'" class="h4">
            <fa-icon [icon]='["far","piggy-bank"]' class="me-2"></fa-icon>
            Banking Information
        </div>
        <div *ngIf="displayModal === 'owner'" class="h4">
            <fa-icon [icon]='["far","user-tie"]' class="me-2"></fa-icon>
            Ownership & Point of Contact Information
        </div>
        <div *ngIf="displayModal === 'rates'" class="h4">
            Payment Service Rates</div>
        <div *ngIf="displayModal === 'terms'" class="h4">
            <fa-icon [icon]='["far","file-contract"]'></fa-icon>Terms and Conditions
        </div>

    </ng-template>
    <div *ngIf="displayModal === 'about'">
        <div class="d-flex">
            <ul>
                <li>Name: the trade name of your restaurant, for example <i>Moe's Tavern</i></li>
                <li>Physical Street Address: the physical address that your restaurant is located at.</li>
                <li>Suite/Unit: do you have a unit number or suite number? Give us that so we can find you.</li>
            </ul>
        </div>
    </div>
    <div *ngIf="displayModal === 'legal'">
        <div class="d-flex">
            <ul>
                <li></li>
            </ul>
        </div>
    </div>
    <div *ngIf="displayModal === 'business'">
        <div class="d-flex">
            <ul>
                <li></li>
            </ul>
        </div>
    </div>
    <div *ngIf="displayModal === 'banking'">
        <div class="d-flex">
            <ul>
                <li></li>
            </ul>
        </div>
    </div>
    <div *ngIf="displayModal === 'owner'">
        <div class="d-flex">
            <ul>
                <li></li>
            </ul>
        </div>
    </div>
    <div *ngIf="displayModal === 'rates'">
        <div class="d-flex">
            <ul>
                <li></li>
            </ul>
        </div>
    </div>
    <div *ngIf="displayModal === 'terms'">
        <div class="d-flex">
            <ul>
                <li></li>
            </ul>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="d-flex">
            <div class="ms-auto">
                <div>
                    <a href="https://help.focusca.com" target="_blank">
                        <p-button pRipple styleClass="p-button-raised p-button-info m-2">
                            <ng-template pTemplate="content">
                                <div class="d-flex justify-content-center">
                                    <fa-icon [icon]='["far","user-md-chat"]' size="lg" class="ml-1 mr-2"></fa-icon>
                                    Chat with our team
                                </div>
                            </ng-template>
                        </p-button>
                    </a>
                </div>
            </div>
        </div>
    </ng-template>
</p-dialog>